import React, { useState } from 'react';
import { OrganizationVideo } from 'lib/api/organizationVideo/useOrganizationVideoQuery';
import {
  CheckboxPreview,
  CheckboxPreviewHeader,
  VehicleLibrary,
  VehicleLibraryHeader,
  VehicleModel,
  VehicleModelHeader,
  VehiclePlaylist,
  VehiclePlaylistHeader,
  VehiclePreview,
  VehiclePreviewHeader,
  VehicleTitle,
  VehicleTitleHeader,
  VehicleYear,
  VehicleYearHeader,
  Video,
  VideoPlay,
  VideosList,
  VideoThumbnailWrapper,
} from '../style';
import { VideoItemThumbnail } from 'app/pages/library/videos/components';
import { BsPlayFill } from 'react-icons/bs';
import { useTheme } from 'styled-components/macro';
import { ModalVideoListVideo } from '../../ModalVideoListVideo';
import { CheckboxInput } from 'lib/components/inputs';

export interface OrganizationVideoDuplicatePlaylistTableProps {
  videos: OrganizationVideo[];
  selectedOrganizationVideos: OrganizationVideo[];
  onOrganizationVideoSelect: (
    video: OrganizationVideo,
    isSelected: boolean
  ) => void;
  onSelectAll: (shouldSelectAll: boolean) => void;
}

export const OrganizationVideoDuplicatePlaylistTable = ({
  videos,
  selectedOrganizationVideos,
  onOrganizationVideoSelect,
  onSelectAll,
}: OrganizationVideoDuplicatePlaylistTableProps) => {
  const theme = useTheme();
  const [videoSource, setVideoSource] = useState('');

  const isAllSelected = selectedOrganizationVideos.length === videos.length;

  return (
    <VideosList
      minHeight='420px'
      style={{ overflowY: 'auto', height: '420px' }}
    >
      <Video>
        <CheckboxPreviewHeader>
          <CheckboxInput
            width='24px'
            blueCheck={true}
            checked={isAllSelected}
            onChange={(e: React.SyntheticEvent) => {
              let { checked } = e.target as HTMLInputElement;
              onSelectAll(checked);
            }}
          />
        </CheckboxPreviewHeader>
        <VehiclePreviewHeader>Preview</VehiclePreviewHeader>
        <VehicleLibraryHeader>Library</VehicleLibraryHeader>
        <VehiclePlaylistHeader>Playlist</VehiclePlaylistHeader>
        <VehicleModelHeader>Model</VehicleModelHeader>
        <VehicleYearHeader>Year</VehicleYearHeader>
        <VehicleTitleHeader>Title</VehicleTitleHeader>
      </Video>
      {videos?.map(video => (
        <Video key={video.organizationVideoId}>
          <CheckboxPreview>
            <CheckboxInput
              width='24px'
              blueCheck={true}
              checked={selectedOrganizationVideos.some(
                v => v.organizationVideoId === video.organizationVideoId
              )}
              onChange={(e: React.SyntheticEvent) => {
                e.stopPropagation();
                let { checked } = e.target as HTMLInputElement;
                onOrganizationVideoSelect(video, checked);
              }}
            />
          </CheckboxPreview>
          <VehiclePreview>
            {video.thumbnailUrl ? (
              <VideoItemThumbnail
                handleClick={() => {
                  if (!!video.videoUrl) {
                    setVideoSource(video.videoUrl);
                  }
                }}
                thumbnail={video.thumbnailUrl}
                videoId={''}
                processing={0}
                thumbnailWidth={'60px'}
                thumbnailHeight={'40px'}
              />
            ) : (
              <VideoThumbnailWrapper
                onClick={() => {
                  if (!!video.videoUrl) {
                    setVideoSource(video.videoUrl);
                  }
                }}
              >
                <video
                  src={video.videoUrl}
                  width={60}
                  height={40}
                  controls={false}
                />

                <VideoPlay>
                  <BsPlayFill color={theme.colors.white[100]} size={30} />
                </VideoPlay>
              </VideoThumbnailWrapper>
            )}
          </VehiclePreview>
          <VehicleLibrary title={video.library}>{video.library}</VehicleLibrary>
          <VehiclePlaylist title={video.playlist}>
            {video.playlist}
          </VehiclePlaylist>
          <VehicleModel title={video.model}>{video.model}</VehicleModel>
          <VehicleYear>{video.year}</VehicleYear>
          <VehicleTitle title={video.title}>{video.title}</VehicleTitle>
        </Video>
      ))}

      {!!videoSource && (
        <ModalVideoListVideo
          videoId={''}
          source={videoSource}
          handleModalClose={() => {
            setVideoSource('');
          }}
          hideContext={true}
        />
      )}
    </VideosList>
  );
};
